import React, { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LockIcon } from '../assets/ic_lock.svg';
import useTenantStore, {
  selectAppId,
  selectTenantId,
} from '../stores/TenantStore';

interface IAppSetupCheckProps {
  pageTitle: string;
}

const AppSetupCheck: FC<IAppSetupCheckProps> = ({ pageTitle }) => {
  const navigate = useNavigate();
  const tenantId = useTenantStore(selectTenantId);
  const appId = useTenantStore(selectAppId);
  const enabled = false;

  if (enabled && tenantId && !appId) {
    return (
      <div className="modal opacity-1 fixed w-full h-full top-0 left-0 flex items-center justify-center z-10">
        <div className="modal-overlay absolute w-full h-full bg-black opacity-80"></div>

        <div className="flex flex-col justify-center text-xl text-center max-w-[500px] z-10">
          <div className="flex flex-col px-6 py-9 w-full bg-white rounded-3xl max-md:px-5 max-md:max-w-full">
            <LockIcon className="self-center w-16 aspect-square" />
            <div className="mt-10 font-semibold leading-8 text-black max-md:max-w-full">
              {`To access "${pageTitle}", you'll need to release your app first.`}
            </div>
            <button
              className="justify-center items-center p-2.5 mt-10 font-medium text-white bg-cyan-700 rounded-3xl leading-[130%] max-md:px-5 max-md:max-w-full"
              onClick={() => {
                navigate('/app-setup');
              }}
            >
              Create an app
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default AppSetupCheck;
